module.exports = __webpack_public_path__ + "static/media/andrew_h.c.a89d8398.jpg";